import { makeStyles } from '@mui/styles';
import FormControl from '@mui/material/FormControl';
import { TextField } from '@mui/material';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { useDispatch } from 'react-redux';
import DropdownFilter from './DropdownFilter';

const useStyles = makeStyles(() => ({
  formControl: {
    margin: 15,
    marginLeft: 10,
    marginRight: 5,
    minWidth: 60,
    width: '30%'
  },
  inputLabel: {
    fontSize: '14px'
  }
}));

const theme = createTheme({
  overrides: {
    MuiInputLabel: {
      root: {
        fontSize: '14px'
      }
    }
  },
});

export default function CalculatedAreaFilter({min, max, setMin, setMax, type, setType, filter}) {
  const classes = useStyles();
  const dispatch = useDispatch();

  const handleChangeMin = (event) => {
    dispatch(setMin(event.target.value));
  };

  const handleChangeMax = (event) => {
    dispatch(setMax(event.target.value));
  };

  return (
    <div>
      <ThemeProvider theme={theme}>
        <FormControl className={classes.formControl}>
          <TextField
            id="standard-number"
            label="Min"
            type="number"
            variant="standard"
            className='inputLabel'
            onChange={handleChangeMin}
            value={min === null ? "" : min}
            name="min"
          />
        </FormControl>
        <FormControl className={classes.formControl}>
          <TextField
            id="standard-number"
            label="Max"
            type="number"
            variant="standard"
            className='inputLabel'
            onChange={handleChangeMax}
            value={max === null ? "" : max}
            name="max"
          />
        </FormControl>
        <FormControl className={classes.formControl}>
          <DropdownFilter filter={filter} setValue={setType} value={type} name={"Unit Type"} wide={false} useThinStyle={true} dropdownChanged={null} />
        </FormControl>
      </ThemeProvider>
    </div>
  );
}

